function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { runInOp } from "../display/operations.js";
import { addToScrollTop } from "../display/scrolling.js";
import { regLineChange } from "../display/view_tracking.js";
import { heightAtLine, lineIsHidden } from "../line/spans.js";
import { lineNo, updateLineHeight } from "../line/utils_line.js";
import { widgetHeight } from "../measurement/widgets.js";
import { changeLine } from "./changes.js";
import { eventMixin } from "../util/event.js";
import { signalLater } from "../util/operation_group.js"; // Line widgets are block elements displayed above or below a line.

export var LineWidget =
/*#__PURE__*/
function () {
  function LineWidget(doc, node, options) {
    _classCallCheck(this, LineWidget);

    if (options) for (var opt in options) {
      if (options.hasOwnProperty(opt)) this[opt] = options[opt];
    }
    this.doc = doc;
    this.node = node;
  }

  _createClass(LineWidget, [{
    key: "clear",
    value: function clear() {
      var cm = this.doc.cm,
          ws = this.line.widgets,
          line = this.line,
          no = lineNo(line);
      if (no == null || !ws) return;

      for (var i = 0; i < ws.length; ++i) {
        if (ws[i] == this) ws.splice(i--, 1);
      }

      if (!ws.length) line.widgets = null;
      var height = widgetHeight(this);
      updateLineHeight(line, Math.max(0, line.height - height));

      if (cm) {
        runInOp(cm, function () {
          adjustScrollWhenAboveVisible(cm, line, -height);
          regLineChange(cm, no, "widget");
        });
        signalLater(cm, "lineWidgetCleared", cm, this, no);
      }
    }
  }, {
    key: "changed",
    value: function changed() {
      var _this = this;

      var oldH = this.height,
          cm = this.doc.cm,
          line = this.line;
      this.height = null;
      var diff = widgetHeight(this) - oldH;
      if (!diff) return;
      if (!lineIsHidden(this.doc, line)) updateLineHeight(line, line.height + diff);

      if (cm) {
        runInOp(cm, function () {
          cm.curOp.forceUpdate = true;
          adjustScrollWhenAboveVisible(cm, line, diff);
          signalLater(cm, "lineWidgetChanged", cm, _this, lineNo(line));
        });
      }
    }
  }]);

  return LineWidget;
}();
eventMixin(LineWidget);

function adjustScrollWhenAboveVisible(cm, line, diff) {
  if (heightAtLine(line) < (cm.curOp && cm.curOp.scrollTop || cm.doc.scrollTop)) addToScrollTop(cm, diff);
}

export function addLineWidget(doc, handle, node, options) {
  var widget = new LineWidget(doc, node, options);
  var cm = doc.cm;
  if (cm && widget.noHScroll) cm.display.alignWidgets = true;
  changeLine(doc, handle, "widget", function (line) {
    var widgets = line.widgets || (line.widgets = []);
    if (widget.insertAt == null) widgets.push(widget);else widgets.splice(Math.min(widgets.length - 1, Math.max(0, widget.insertAt)), 0, widget);
    widget.line = line;

    if (cm && !lineIsHidden(doc, line)) {
      var aboveVisible = heightAtLine(line) < doc.scrollTop;
      updateLineHeight(line, line.height + widgetHeight(widget));
      if (aboveVisible) addToScrollTop(cm, widget.height);
      cm.curOp.forceUpdate = true;
    }

    return true;
  });
  if (cm) signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle));
  return widget;
}